import React, {
	cloneElement,
	Component,
	CSSProperties,
	PropsWithChildren,
	useCallback,
	useEffect,
	useState,
} from "react";
import sass from "./index.module.sass";

type UseAnimateProps = {
	mount: string;
	//     {
	//     style: CSSProperties;
	//     delay: number;
	// };
	unMount: string;
	//     {
	//     style: CSSProperties;
	//     delay: number;
	// };
	delay: number;
	firstUnMount?: boolean;
};
export const useAnimate = (config: UseAnimateProps) => {
	const { mount, unMount, delay } = config;
	const [style, setStyle] = useState<string>(config.firstUnMount ? unMount : mount);

	// /** un-mount */
	const handleClose = useCallback(
		(handleClick: () => void) => {
			setStyle(unMount);

			let timer = setTimeout(() => handleClick(), delay);
			return () => clearTimeout(timer);
			//eslint-disable-next-line
		}, [unMount],
	);

	/** mount */
	useEffect(() => {
		setStyle(mount);
		//eslint-disable-next-line
	}, []);

	return { handleClose, className: style };
};

interface IAnimateTemp extends PropsWithChildren {
	ref: any;
}
const AnimateTemp: React.FC<IAnimateTemp> = ({ children }) => {
	/*eslint-disable*/
	const [fadeOut] = useState(false);
	const [component, setComponent] = useState<any>();

	useEffect(() => {
		if (children) {
			setComponent(cloneElement(children as any, { className: fadeOut ? sass.exit : "" }));
		}
	}, [children]);

	useEffect(() => {}, []);

	return component;
};

interface IANPROPS extends PropsWithChildren {
	mount: {
		style: CSSProperties;
		delay: number;
	};
	unMount: {
		style: CSSProperties;
		delay: number;
	};
}

interface IANSTATE {
	style: CSSProperties;
	delay: number;
}

class An extends Component<IANPROPS, IANSTATE> {
	timer: any;
	static style: CSSProperties;
	constructor(props: IANPROPS) {
		super(props);
		this.state = {
			style: {},
			delay: 0,
		};
		An.anyFunc = An.anyFunc.bind({ changeStyle: this.changeStyle });
	}
	componentDidMount() {
		this.setState({
			style: { ...this.props.mount.style, transition: `all linear ${this.props.mount.delay / 1000}` },
			delay: this.props.mount.delay,
		});
	}

	componentWillUnmount() {
		this.timer && clearTimeout(this.timer);
		this.timer = null;
	}
	static anyFunc() {}
	private changeStyle(cb: () => void) {
		this.setState({
			style: { ...this.props.unMount.style, transition: `all linear ${this.props.unMount.delay / 1000}` },
			delay: this.props.unMount.delay,
		});
		this.timer = setTimeout(() => {
			cb();
		}, this.state.delay);
	}

	render() {
		return cloneElement(this.props.children as any, { style: this.state.style });
	}
}

export default AnimateTemp;
